import { Link } from 'react-router-dom';

interface HeroBannerProps {
  siteConfig: {
    name: string;
    tagline: string;
    description: string;
  };
}

export default function HeroBanner({ siteConfig }: HeroBannerProps) {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20Japanese%20anime%20art%20background%2C%20dramatic%20vermillion%20and%20crimson%20sunset%20sky%20with%20silhouetted%20cherry%20blossom%20trees%2C%20ink%20wash%20painting%20style%2C%20floating%20golden%20particles%2C%20ancient%20pagoda%20silhouette%20on%20distant%20hill%2C%20atmospheric%20mist%2C%20cinematic%20composition%2C%20dark%20moody%20edges%2C%20elegant%20artistic%20illustration&width=1920&height=800&seq=hero-bg-2026&orientation=landscape"
          alt="成人动漫精选推荐 - 探索成人动漫世界"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
          {siteConfig.name}
        </h1>
        <p className="text-base md:text-lg text-background-50/90 mb-3 max-w-2xl mx-auto leading-relaxed">
          {siteConfig.tagline}
        </p>
        <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-xl mx-auto leading-relaxed">
          {siteConfig.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/story"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览分类
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <a
            href="#ranking"
            className="px-8 py-3 border border-background-50/30 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看排行榜
            <i className="ri-medal-line ml-2"></i>
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}